<script setup lang="ts">
import type { CategoriesComponentModel } from '@su4r-frontend/api';
defineProps<CategoriesComponentModel>();

const localeRoute = useLocaleRoute();
</script>

<template>
    <section
        class="tile bg-blue-medium grid grid-rows-1 items-center gap-y-4 lg:grid-cols-2 lg:gap-6">
        <div class="flex flex-col gap-4">
            <header class="flex flex-col gap-4">
                <h2 v-if="title" class="order-2 text-3xl">{{ title }}</h2>
                <h3 v-if="subtitle" class="font-body order-1">{{ subtitle }}</h3>
            </header>
            <div v-html="body"></div>
            <NuxtLink
                v-if="link"
                :to="localeRoute(link.url)"
                class="btn-secondary-a hidden lg:flex"
                :target="link.openInNewTab ? '_blank' : '_self'"
                >{{ link.title }}</NuxtLink
            >
        </div>
        <div
            class="-m-0.5 flex flex-row flex-nowrap gap-2 overflow-auto p-0.5 whitespace-nowrap lg:m-0 lg:flex-wrap lg:justify-end lg:overflow-visible lg:p-0 lg:whitespace-normal">
            <NuxtLink
                v-for="(item, index) in categories"
                :key="`category-${index}`"
                class="chip-dark"
                :to="localeRoute(item.slug ?? '/')"
                >{{ item.title }}</NuxtLink
            >
        </div>
        <NuxtLink
            v-if="link"
            :to="localeRoute(link.url)"
            class="btn-secondary-a lg:hidden"
            :target="link.openInNewTab ? '_blank' : '_self'"
            >{{ link.title }}</NuxtLink
        >
    </section>
</template>
